<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('storeOrderLogistics.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="storeOrderLogisticsInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              v-model="storeOrderLogisticsInfo.conditions.orderId"
              :placeholder="$t('storeOrderLogistics.orderIdPlaceholder')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="storeOrderLogisticsInfo.conditions.solNum"
              :placeholder="$t('storeOrderLogistics.solNumPlaceholder')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="storeOrderLogisticsInfo.conditions.solCompany"
              :placeholder="$t('storeOrderLogistics.solCompanyPlaceholder')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="storeOrderLogisticsInfo.conditions.state"
              :placeholder="$t('storeOrderLogistics.statePlaceholder')"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in storeOrderLogisticsInfo.states"
                :key="item.statusCd"
                :label="item.name"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryStoreOrderLogisticsMethod">
              {{ $t('storeOrderLogistics.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('storeOrderLogistics.orderLogistics') }}</span>
      </div>
      <div class="">
        <el-table
          :data="storeOrderLogisticsInfo.logisticss"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="orderId"
            :label="$t('storeOrderLogistics.orderId')"
            align="center"
          />
          <el-table-column
            prop="solNum"
            :label="$t('storeOrderLogistics.solNum')"
            align="center"
          />
          <el-table-column
            prop="solCompanyName"
            :label="$t('storeOrderLogistics.solCompany')"
            align="center"
          />
          <el-table-column
            prop="username"
            :label="$t('storeOrderLogistics.username')"
            align="center"
          />
          <el-table-column
            prop="address"
            :label="$t('storeOrderLogistics.address')"
            align="center"
          />
          <el-table-column
            prop="tel"
            :label="$t('storeOrderLogistics.tel')"
            align="center"
          />
          <el-table-column
            prop="stateName"
            :label="$t('storeOrderLogistics.state')"
            align="center"
          />
          <el-table-column
            prop="curPos"
            :label="$t('storeOrderLogistics.curPos')"
            align="center"
          />
          <el-table-column
            prop="remark"
            :label="$t('storeOrderLogistics.remark')"
            align="center"
          />
          <el-table-column
            prop="createTime"
            :label="$t('storeOrderLogistics.createTime')"
            align="center"
          />
          <el-table-column
            :label="$t('storeOrderLogistics.operation')"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="_toStoreOrderDetial(scope.row)"
              >
                {{ $t('storeOrderLogistics.orderDetail') }}
              </el-button>
              <el-button
                size="mini"
                @click="_openStoreOrderLogisticsModal(scope.row)"
              >
                {{ $t('storeOrderLogistics.logistics') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="storeOrderLogisticsInfo.conditions.page"
          :page-size="storeOrderLogisticsInfo.conditions.row"
          layout="total, prev, pager, next"
          :total="storeOrderLogisticsInfo.total"
        />
      </div>
    </el-card>

    <show-store-order-express ref="showStoreOrderExpress" />
  </div>
</template>

<script>
import { listStoreOrderLogistics } from '@/api/order/storeOrderLogisticsApi'
import ShowStoreOrderExpress from '@/components/order/showStoreOrderExpress'
import { getShopId, getDict } from '@/api/shop/shopApi'

export default {
  name: 'StoreOrderLogistics',
  components: {
    ShowStoreOrderExpress
  },
  data() {
    return {
      storeOrderLogisticsInfo: {
        logisticss: [],
        total: 0,
        states: [],
        conditions: {
          orderId: '',
          solNum: '',
          solCompany: '',
          state: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initDicts()
    this._listStoreOrderLogisticss(1, 10)
  },
  methods: {
    async _initDicts() {
      try {
        const { data } = await getDict('store_order_logistics', 'state')
        this.storeOrderLogisticsInfo.states = data || []
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listStoreOrderLogisticss(page, rows) {
      this.storeOrderLogisticsInfo.conditions.page = page
      this.storeOrderLogisticsInfo.conditions.row = rows
      let shopId = await getShopId();
      this.storeOrderLogisticsInfo.conditions.shopId = shopId
      
      try {
        const res = await listStoreOrderLogistics(this.storeOrderLogisticsInfo.conditions)
        this.storeOrderLogisticsInfo.total = res.total
        this.storeOrderLogisticsInfo.logisticss = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryStoreOrderLogisticsMethod() {
      this._listStoreOrderLogisticss(1, 10)
    },
    _openStoreOrderLogisticsModal(order) {
      this.$refs.showStoreOrderExpress.open(order)
    },
    _toStoreOrderDetial(order) {
      this.$router.push(`/pages/goods/storeOrderCartDetail?orderId=${order.orderId}`)
    },
    handleCurrentChange(val) {
      this._listStoreOrderLogisticss(val, this.storeOrderLogisticsInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.card-body {
  padding: 20px;
}
</style>